import { log } from '@/log'
import { ApiContent } from '@/models/api/content'
import { ApiClient, ApiClientWithAuth } from '@/services/api/client'
import { Either, left, right } from 'fp-ts/lib/Either'

export class ConditionalFreeContentsService {
  static createForBrand(brand: string): ConditionalFreeContentsService {
    return new ConditionalFreeContentsService(brand)
  }
  static createForHost(): ConditionalFreeContentsService {
    return new ConditionalFreeContentsService(null)
  }
  private constructor(
    private readonly brandEnglishName: string | null,
    private readonly apiClient: typeof ApiClient = ApiClientWithAuth
  ) {}

  async get(name: string): Promise<Either<Error, ApiContent>> {
    try {
      const response = await this.apiClient.get(this.createUrl(name))

      log.debug({ service: 'ConditionalFreeContents/get', response })

      return right(new ApiContent(response.body))
    } catch (error) {
      log.error({ service: 'ConditionalFreeContents/get', error })

      return left(error)
    }
  }

  private createUrl(name: string): string {
    if (this.brandEnglishName === null) {
      return `/api/user/free-contents/${name}`
    }

    return `/api/user/${this.brandEnglishName}/free-contents/${name}`
  }
}
